// eslint-disable @typescript-eslint/naming-convention

const queryParamCharToGqlFilterCharMap = { _: '.', '-': '/' };
export const queryParamWeightToGqlFilterValue = (queryParamWeight: string): string =>
  queryParamWeight.replace(/_|-/, (char: string) => queryParamCharToGqlFilterCharMap[char]);

const gqlFilterCharToQueryParamCharMap = { '.': '_', '/': '-' };
export const gqlFilterWeightToQueryParamValue = (gqlWeight: string): string =>
  gqlWeight.replace(/\.|\//, (char: string) => gqlFilterCharToQueryParamCharMap[char]);
